module.exports = __webpack_public_path__ + "img/5-4.4b744f8c.png";